import { ArrowDown } from "lucide-react";

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative min-h-screen pt-36 md:pt-44 pb-20 px-6 md:px-12 lg:px-24 overflow-hidden bg-white"
        >
            <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
                {/* Left: Text */}
                <div className="lg:col-span-7 relative z-10">
                    <p className="eyebrow mb-6" data-testid="hero-eyebrow">
                        Créatrice de contenu &amp; UGC à Bordeaux
                    </p>
                    <h1
                        className="font-display text-[14vw] sm:text-[10vw] lg:text-[7.5vw] leading-[0.95] tracking-tighter text-ink"
                        data-testid="hero-title"
                    >
                        Je teste. Je filme.<br />
                        Je <span className="italic font-normal text-fuchsia">partage</span>.
                    </h1>
                    <p className="mt-10 max-w-xl text-[#4A4A4A] text-base md:text-lg leading-relaxed">
                        Food, sorties, beauté et lifestyle : je crée des contenus qui mettent en
                        lumière les produits, lieux et expériences qui méritent d'être découverts.
                    </p>

                    <div className="mt-12 flex flex-wrap items-center gap-4">
                        <a
                            href="#contact"
                            data-testid="hero-cta-primary"
                            className="inline-flex items-center gap-3 bg-bordeaux text-white px-8 py-4 text-xs uppercase tracking-[0.22em] hover:bg-fuchsia transition-colors"
                        >
                            Travailler avec moi
                            <span className="block w-6 h-px bg-white" />
                        </a>
                        <a
                            href="#portfolio"
                            data-testid="hero-cta-secondary"
                            className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.22em] text-ink hover:text-fuchsia transition-colors"
                        >
                            Voir le portfolio
                            <ArrowDown className="w-3.5 h-3.5" />
                        </a>
                    </div>

                    <div className="mt-16 hidden md:flex items-center gap-10 text-xs">
                        <a
                            href="#contact"
                            className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.22em] text-ink hover:text-fuchsia transition-colors"
                            data-testid="hero-secondary-link"
                        >
                            Disponible pour collaborations
                            <span className="w-12 h-px bg-current" />
                        </a>
                    </div>
                </div>

                {/* Right: Image */}
                <div className="lg:col-span-5 relative">
                    <div className="relative aspect-[4/5] overflow-hidden bg-[#FAFAFA]">
                        <img
                            src="/melanie-hero.png"
                            alt="Mélanie Perez, créatrice de contenu et UGC à Bordeaux"
                            className="w-full h-full object-cover object-center"
                            data-testid="hero-image"
                        />
                        {/* Dégradé lisibilité sur le bas */}
                        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black/70 via-black/30 to-transparent pointer-events-none" />
                        <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between text-white">
                            <p
                                className="font-display italic text-2xl md:text-3xl leading-tight"
                                style={{ textShadow: "0 2px 18px rgba(0,0,0,0.55)" }}
                            >
                                L'art de raconter<br />les belles adresses.
                            </p>
                            <span className="text-[10px] uppercase tracking-[0.3em] opacity-80 ml-4 shrink-0">
                                © 2026
                            </span>
                        </div>
                    </div>
                    {/* Gold ornament */}
                    <div className="absolute -top-6 -left-6 hidden lg:block">
                        <span className="block w-24 h-24 border border-gold rotate-45" />
                    </div>
                </div>
            </div>

            {/* Decorative side label */}
            <div className="hidden xl:flex absolute left-6 top-1/2 -translate-y-1/2 -rotate-90 origin-left">
                <span className="eyebrow">scroll · scroll · scroll ·</span>
            </div>
        </section>
    );
}
